import React, { useState, useEffect, useContext } from 'react'
import { Checkbox, Button, InputNumber } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { FlexColumn, FlexRow } from '../../FlexboxReusables/FlexItems'
import { Course } from '../../Course/types'
import { CourseContext } from '../../Course/CourseContext'

type ReviewPurchasePriceProps = {
  course: Course
}

const ReviewPurchasePrice: React.FC<ReviewPurchasePriceProps> = ({ course }) => {
  const intl = useIntl()
  const { saveCourse, updateCourse } = useContext(CourseContext)

  const [ courseCanBePurchased, setCourseCanBePurchased ] = useState(course.canBePurchased || false)
  const [ price, setPrice ] = useState(course.purchasePrice || 0)

  useEffect(() => {
    if (courseCanBePurchased && price) {
      updateCourse({
        ...course,
        canBePurchased: courseCanBePurchased,
        purchasePrice: price,
      })
    }
  }, [ courseCanBePurchased, price ])

  return (
    <Container>
      <FlexColumn alignItems='center'>
        <FlexRow margin='1em 0'>
          <Checkbox
            checked={courseCanBePurchased}
            onChange={() => setCourseCanBePurchased(!courseCanBePurchased)}
          >
            <FormattedMessage id='purchaseOptions.canBePurchased' />
          </Checkbox>
        </FlexRow>
        <FlexRow>
          <FormattedMessage id='purchaseOptions.purchasePrice' />
        </FlexRow>
        <FlexRow margin='0.5em 0 0 0'>
          <InputNumber
            defaultValue={price || 0}
            onChange={(value: number | null) => setPrice(value || 0)}
            disabled={!courseCanBePurchased}
          />
          <CurrencySymbol>€</CurrencySymbol>
        </FlexRow>
        <FlexRow margin='2em 0'>
          <Button
            type='primary'
            onClick={() => saveCourse(course, intl)}
            disabled={!course.hasUnsavedChanges}
          >
            <FormattedMessage id='generic.save' />
          </Button>
        </FlexRow>
      </FlexColumn>
    </Container>
  )
}

export default ReviewPurchasePrice

const Container = styled.div`
  min-height: 30vh;
`

const CurrencySymbol = styled.div`
  margin-left: 0.5em;
`